import listActions from 'src/modules/modeloTarea/list/modeloTareaListActions';
import ModeloTareaService from 'src/modules/modeloTarea/modeloTareaService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'MODELOTAREA_DESTROY';

const modeloTareaDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: modeloTareaDestroyActions.DESTROY_STARTED,
      });

      await ModeloTareaService.destroyAll([id]);

      dispatch({
        type: modeloTareaDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.modeloTarea.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/modelo-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: modeloTareaDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: modeloTareaDestroyActions.DESTROY_ALL_STARTED,
      });

      await ModeloTareaService.destroyAll(ids);

      dispatch({
        type: modeloTareaDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.modeloTarea.destroyAll.success'),
      );

      getHistory().push('/modelo-tarea');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: modeloTareaDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default modeloTareaDestroyActions;
